import gqlTagGira from 'graphql-tag';
import { JWM_CATEGORY_OPTIONS_FRAGMENT } from '@atlassian/jira-business-categories/src/common/graphql/gql.tsx';

export const LIST_VIEW_ITEM_GROUPS_QUERY = gqlTagGira`
    query JWMListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        groups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "groups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${JWM_CATEGORY_OPTIONS_FRAGMENT}
`;

// this query is loaded in the background and don't show up in the view. After completed, it replaces the results of the main list
export const BACKGROUND_LIST_VIEW_ITEMS_GROUPS_QUERY = gqlTagGira`
    query JiraBusinessBackgroundListViewItemGroupsWithPagination ($jql: String!, $groupByFieldId: ID!, $fieldIds: [String]!, $first: Int, $last: Int, $before: String, $after: String) {
        backgroundGroups: jwmItemGroups(jql: $jql, groupByFieldId: $groupByFieldId, fieldIds: $fieldIds, first: $first, last: $last, before: $before, after: $after) @connection (key: "backgroundGroups", filter:["jql", "groupByFieldId"]) {
            totalCount
            nodes {
                id
                field {
                    __typename
                    ...on StatusField {
                        fieldKey
                        name
                        statusId
                        statusCategoryId
                    }
                    ... on PriorityField {
                        fieldKey
                        name
                        id
                        iconUrl
                    }
                    ... on UserField {
                        fieldKey
                        userValue {
                            displayName
                            avatarUrl
                            accountId
                        }
                    }
                    ... on JWMCategoryCustomField {
                        fieldKey
                        selectedValue {
                            optionId
                            value
                        }
                        category {
                            ...JwmCategoryOptionsFragment
                        }
                    }
                    ... on SelectCustomField {
                        fieldKey
                        selectedValue {
                          optionId
                          value
                        }
                    }
                    ... on FloatCustomField {
                        fieldKey
                        floatValue
                    }
                    ... on SprintCustomField {
                        fieldKey
                        title
                        values {
                            id
                            name
                            state
                        }
                    }
                }
                totalCount
            }
            pageInfo {
                hasNextPage
                endCursor
            }
        }
    }
    ${JWM_CATEGORY_OPTIONS_FRAGMENT}
`;
